import { Dispatch } from 'react'
import {
  AmountInfo,
  GoalInfo,
  LocationConfig,
  OrganizationInfo,
  PaymentInfo,
  RuleInfo,
  VoucherInfo,
} from '../../api/types'
import { LocationDesignConfig } from '../../configs/types'
import {
  SET_AMOUNT,
  SET_GOALS,
  SET_LOCATION_CONFIG,
  SET_LOCATION_DESIGN_CONFIG,
  SET_ORGANIZATIONS,
  SET_PAYMENT_INFO,
  SET_RULES,
  SET_SELECTED_GOAL,
  SET_SELECTED_ORGANIZATION,
  SET_VOUCHERS,
} from './constants'
import { AppContextAction } from './types'

export const setLocationDesignConfig = (
  dispatch: Dispatch<AppContextAction>,
  locationDesignConfig: LocationDesignConfig
) => {
  dispatch({
    type: SET_LOCATION_DESIGN_CONFIG,
    locationDesignConfig,
  })
}

export const setLocationConfig = (
  dispatch: Dispatch<AppContextAction>,
  locationConfig: LocationConfig
) => {
  dispatch({
    type: SET_LOCATION_CONFIG,
    locationConfig,
  })
}

export const setOrganizations = (
  dispatch: Dispatch<AppContextAction>,
  organizations: OrganizationInfo[]
) => {
  dispatch({
    type: SET_ORGANIZATIONS,
    organizations,
  })
}

export const setSelectedOrganization = (
  dispatch: Dispatch<AppContextAction>,
  selectedOrganization: OrganizationInfo | null
) => {
  dispatch({
    type: SET_SELECTED_ORGANIZATION,
    selectedOrganization,
  })
}

export const setGoals = (
  dispatch: Dispatch<AppContextAction>,
  goals: GoalInfo[]
) => {
  dispatch({
    type: SET_GOALS,
    goals,
  })
}

export const setSelectedGoal = (
  dispatch: Dispatch<AppContextAction>,
  selectedGoal: GoalInfo | null
) => {
  dispatch({
    type: SET_SELECTED_GOAL,
    selectedGoal,
  })
}

export const setAmount = (
  dispatch: Dispatch<AppContextAction>,
  amount: AmountInfo
) => {
  dispatch({
    type: SET_AMOUNT,
    amount,
  })
}

export const setRules = (
  dispatch: Dispatch<AppContextAction>,
  rules: RuleInfo[]
) => {
  dispatch({
    type: SET_RULES,
    rules,
  })
}

export const setVouchers = (
  dispatch: Dispatch<AppContextAction>,
  vouchers: VoucherInfo[]
) => {
  dispatch({
    type: SET_VOUCHERS,
    vouchers,
  })
}

export const setPaymentInfo = (
  dispatch: Dispatch<AppContextAction>,
  paymentInfo: PaymentInfo
) => {
  dispatch({
    type: SET_PAYMENT_INFO,
    paymentInfo,
  })
}
